import { render, staticRenderFns } from "./Badge3.vue?vue&type=template&id=ba7dbb10&scoped=true"
import script from "./Badge3.vue?vue&type=script&lang=js"
export * from "./Badge3.vue?vue&type=script&lang=js"
import style0 from "./Badge3.vue?vue&type=style&index=0&id=ba7dbb10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7dbb10",
  null
  
)

export default component.exports